import React from 'react';
import { useInView } from 'react-intersection-observer';
import './SectionDivider.css';

const SectionDivider = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5
    });

    return (
        <div className="section-divider" ref={ref}>
            <div className={`divider-line ${inView ? 'visible' : ''}`} />
            <div className={`divider-diamond ${inView ? 'visible' : ''}`} />
            <div className="divider-glow" />
        </div>
    );
};

export default SectionDivider;
